import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import SobreSection from "./components/SobreSection";
import EmpresasSection from "./components/EmpresasSection";
import PessoaFisicaSection from "./components/PessoaFisicaSection";
import AreasSection from "./components/AreasSection";
import DiferenciaisSection from "./components/DiferenciaisSection";
import CTASection from "./components/CTASection";
import ContatoSection from "./components/ContatoSection";

export default function HomePage() {
  return (
    <div className="font-body text-grafite antialiased">
      <Navbar />
      <main>
        <HeroSection />
        <SobreSection />
        <EmpresasSection />
        <PessoaFisicaSection />
        <AreasSection />
        <DiferenciaisSection />
        <CTASection />
        <ContatoSection />
      </main>
      <Footer />
    </div>
  );
}
